<template>
  <div>
    <vue-select  style="width: 100%;font-size: var(--font-primary);" :disabled="off" :placeholder="$t('Seçin')" filterable :value="selected" @input="handleInput"
      :clearable="true"  :options="data" :label="$t('name')" :option-key="'id'" :reduce="data => data.id">
    </vue-select>
  </div>
</template>

<script>
import { GetOfficialAgency } from "../../services/cls";
export default {
  props: {
    value: [Number, String],
    disabled: Boolean,
  },
  data() {
    return {
      data: [],
      selected: this.value,
      off: this.disabled,
    };
  },
  methods: {
    handleInput(e) {
      this.$emit("input", e);
      this.selected = e;
    },

    getData() {
      GetOfficialAgency().then((response) => {
        if (response.data.data) {
          this.data = response.data.data;
        } else {
          this.$message({
            type: "error",
            message: "Official Agency: No data found!",
          });
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    value() {
      this.selected = this.value;
    },
    disabled() {
      this.off = this.disabled;
    },
  },
};
</script>
<style>



</style>
